// @flow
// @jsx h
import { h } from "preact";

import styles from "./style.scss";
import { Text } from "preact-i18n";
import ProductMap from "./productmap";

/**
 * Product address and map component
 */
const MapTab = props =>
  props.address && props.displayMap ? (

    <div class={styles.mapContent}>
      <ProductMap
        marker={{
          position: {
            lat: props.address.latitude,
            lng: props.address.longitude
          },
          key: props.product.name,
          defaultAnimation: 2
        }}
        class={styles.mapElement}
      />
          { props.product.type == "GIFT" && (
      <div class={styles.label}><Text id="product.map.adresseVendeur">Adresse du vendeur</Text> :</div>
                )}
      <div class={styles.address}>
        <div class={styles.row}>
          {props.address.address1} {props.address.address2}
          {", "}
          {props.address.zipCode} {props.address.city}
        </div>
        {props.address.state && (
          <div class={styles.row}>{props.address.state}</div>
        )}
      </div>
    </div>
  ) : null;

export default MapTab;
